export default "For sounds, this noise shows up as static.\n"